import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, finalize } from 'rxjs';

import { TranslateCodePipe } from '@widgets/translate-code.pipe';

enum JustDoneWidgetState {
  Success,
  Fail,
}

@UntilDestroy()
@Component({
  selector: 'app-just-done-widget',
  templateUrl: './just-done-widget.component.html',
  styleUrls: ['./just-done-widget.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateCodePipe],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class JustDoneWidgetComponent implements OnInit {
  state: JustDoneWidgetState;
  JustDoneWidgetState = JustDoneWidgetState;
  errorCode = 'Failure';
  doneText: string;

  get jwtToken(): string {
    return this.route.snapshot.queryParams.jwt;
  }

  constructor(protected cdr: ChangeDetectorRef, private route: ActivatedRoute) {}

  protected abstract doWork(jwtToken: string): Observable<null>;
  protected abstract getDoneText(): string;

  ngOnInit() {
    this.doneText = this.getDoneText();

    this.doWork(this.jwtToken)
      .pipe(finalize(() => this.cdr.detectChanges()))
      .subscribe({
        next: () => (this.state = JustDoneWidgetState.Success),
        error: err => {
          this.errorCode = err?.error?.Message ?? err?.error ?? '';
          this.state = JustDoneWidgetState.Fail;
        },
      });
  }
}
